export const viewTitle = "Список АК";
export const viewUniqKey = "ak";
